import React from 'react';
import { Outlet } from 'react-router-dom';

const WithoutNavBar = () => {
    return (
        <Outlet />
    );
};

export default WithoutNavBar;